import colors from "../base/colors";

const iconButton = {
  styleOverrides: {
    root: {
      borderRadius: 5,
      "&:hover": {
        backgroundColor: "transparent",
        color: colors.primary.light,
      },
    },
  },
};
export default iconButton;
